import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const institutionProductCardDefaultVariants = {
  "hasBeforeContent": false
}
const institutionProductCardCompoundVariants = []

const institutionProductCardSlotNames = [
  [
    "listItem",
    "institution-product-card__listItem"
  ],
  [
    "grid",
    "institution-product-card__grid"
  ],
  [
    "before",
    "institution-product-card__before"
  ],
  [
    "name",
    "institution-product-card__name"
  ],
  [
    "nameText",
    "institution-product-card__nameText"
  ],
  [
    "image",
    "institution-product-card__image"
  ],
  [
    "ratings",
    "institution-product-card__ratings"
  ],
  [
    "traditionalTerms",
    "institution-product-card__traditionalTerms"
  ],
  [
    "cta",
    "institution-product-card__cta"
  ],
  [
    "drivers",
    "institution-product-card__drivers"
  ],
  [
    "nerdwalletTake",
    "institution-product-card__nerdwalletTake"
  ]
]
const institutionProductCardSlotFns = /* @__PURE__ */ institutionProductCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, institutionProductCardDefaultVariants, getSlotCompoundVariant(institutionProductCardCompoundVariants, slotName))])

const institutionProductCardFn = memo((props = {}) => {
  return Object.fromEntries(institutionProductCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const institutionProductCardVariantKeys = [
  "hasBeforeContent"
]
const getVariantProps = (variants) => ({ ...institutionProductCardDefaultVariants, ...compact(variants) })

export const institutionProductCard = /* @__PURE__ */ Object.assign(institutionProductCardFn, {
  __recipe__: false,
  __name__: 'institutionProductCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: institutionProductCardVariantKeys,
  variantMap: {
  "hasBeforeContent": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, institutionProductCardVariantKeys)
  },
  getVariantProps
})